import { LOAD_PRIVACY_DATA, LoadPrivacyAction, SET_PRIVACY_DATA, SetPrivacyAction } from './privacy.types';

export const loadPrivacyAction = (): LoadPrivacyAction => ({ type: LOAD_PRIVACY_DATA });
export const setPrivacyAction = (data: string): SetPrivacyAction => ({ type: SET_PRIVACY_DATA, payload: data });
